/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Items_Unlinked_GenericInputs */

const vi_error_kiotviet_items_unlinked_generic = /** @type {(inputs: Error_Kiotviet_Items_Unlinked_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn còn dòng KiotViet chưa nối sản phẩm. Nối sản phẩm trước khi xuất kho.`)
};

/**

* @param {Error_Kiotviet_Items_Unlinked_GenericInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_items_unlinked_generic = /** @type {((inputs?: Error_Kiotviet_Items_Unlinked_GenericInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Items_Unlinked_GenericInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_items_unlinked_generic(inputs)
});